import { Alert, Snackbar } from "@mui/material";
import { toasterStyle } from "./toasterStyle";

function Toaster({
  severity = "success",
  message = "Add your message",
  open = false,
  handleClose = () => {},
}) {
  return (
    <Snackbar
      autoHideDuration={3000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      // eslint-disable-next-line
      key={"top" + "center"}
      onClose={handleClose}
      // Hardcoded (no theme lookup) so it stays above every modal/backdrop.
      sx={{ zIndex: "9999 !important" }}
    >
      <Alert
        // @ts-ignore
        severity={severity}
        variant="standard"
        sx={toasterStyle.alertStyle(severity)}
        onClose={handleClose}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default Toaster;
